import { marked } from 'marked';
import './MarkdownRenderer.css';

/**
 * Component to render Markdown text as HTML with proper styling
 */
function MarkdownRenderer({ content, className = '' }) {
  if (!content) return null;

  // Configure marked options for better rendering
  marked.setOptions({
    breaks: true, // Convert line breaks to <br>
    gfm: true,    // Enable GitHub Flavored Markdown
  });

  // Convert markdown to HTML
  const htmlContent = marked(content);

  return (
    <div 
      className={`markdown-content ${className}`}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

export default MarkdownRenderer;
